import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import {AssetEmpty} from "site-apps/devices/DevicesModels";
import ModalSelectAsset from "site-apps/assets/ModalSelectAsset";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import {Link} from "react-router-dom";

const urlMedia = process.env?.REACT_APP_MEDIA_URL || "/media";
const imageDefault = "/static/images/noimage.png"

const TabAsset = ({item}) => {
    const [asset, setAsset] = useState({...AssetEmpty})
    const [showChoiceAsset, setShowChoiceAsset] = useState(false)

    const onClickButtonAsset = () => {
        setShowChoiceAsset(true);
        subscribeEvent("changeselectedasset", changeAsset);
    }
    const changeAsset = (e) => {
        setAsset(e.detail)
        unsubscribeEvent("changeselectedasset", changeAsset);
    }

    useEffect(() => {
        if (!item.asset) {
            item.asset = {...AssetEmpty}
        }
        setAsset(item.asset)
        return () => {
            unsubscribeEvent("changeselectedasset", changeAsset);
        }
    }, []);

    return <>
        <div className="row">
            <div className="col-md-4 text-md-end">
                {asset.image === ""
                    ? <img
                        src={imageDefault}
                        height="120"
                        className="d-inline-block align-top pt-1 pb-1 pe-1"
                        alt="no image"
                    />
                    : <img
                        src={urlMedia + "/" + asset.image}
                        height="120"
                        className="d-inline-block align-top pt-1 pb-1 pe-1"
                        alt={"image " + asset.name}
                    />

                }
            </div>
            <div className="col-md-8 mt-2">
                <input type="hidden" id="asset" name="asset" defaultValue={asset.id} readOnly={true}/>
                <div className="row">
                    <div className="col-md-2 text-md-end mt-2">
                        <label htmlFor="asset" className="form-label">Asset</label>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <input type="text" className="form-control mb-2"
                                   id="asset_name"
                                   defaultValue={asset.uid}
                                   disabled={true}
                                   readOnly={true}
                                   required
                            />
                            <Button className="mb-2" variant="link" type="button"
                                    onClick={onClickButtonAsset}>
                                <FontAwesomeIcon icon="magnifying-glass"/>
                            </Button>
                            <Link to={"/asset-management/containers/?uid=" + asset.uid} className="mb-2"><FontAwesomeIcon icon="eye"/></Link>
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className="col-md-2 text-md-end mt-2">
                        <label className="form-label">Nombre</label>
                    </div>

                    <div className="col-md-6">
                        <input type="text" className="form-control mb-2"
                               defaultValue={asset.name} disabled={true} readOnly={true}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className="col-md-2 text-md-end mt-2">
                        <label className="form-label">Active</label>
                    </div>

                    <div className="col-md-6">
                        <input type="text" className="form-control mb-2"
                               defaultValue={asset.active} disabled={true} readOnly={true}/>
                    </div>
                </div>

            </div>

        </div>


        <div className="row mt-4">
            <div className="col-md-3 text-md-end mt-2">
                <label className="form-label">Address</label>
            </div>
            <div className="col-md-6">
                <input type="text" className="form-control mb-2"
                       defaultValue={asset.full_address} disabled={true} readOnly={true}/>
            </div>
        </div>

        <div className="row">
            <div className="col-md-3 text-md-end mt-2">
                <label className="form-label">Description</label>
            </div>
            <div className="col-md-6">
                <textarea
                    className="form-control"
                    defaultValue={asset.description}
                    disabled={true}
                    readOnly={true}
                    rows={4}
                />
            </div>
        </div>

        <ModalSelectAsset
            show={showChoiceAsset}
            setShow={setShowChoiceAsset}
        />

    </>
}

export default TabAsset